import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) {
      // Store the current location in localStorage
      localStorage.setItem('redirectPath', JSON.stringify(location));
      navigate('/prisijungimas', { state: { to: location } });
    }
  }, [navigate, token, location]);

  if (!token) {
    return null; // Prevent rendering children if not authenticated
  }

  return <>{children}</>;
};

export default PrivateRoute;
